module.exports = __webpack_public_path__ + "img/empty-task.bb87a442.svg";